import styled from '@emotion/styled';

import IconStar from '@/assets/icons/icon-star.svg';

export const ProductRating = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;

  .icon-star {
    width: 12px;
    height: 12px;
    background: url(${IconStar}) no-repeat;
    background-size: contain;
    display: inline-block;
    margin-right: 4px;
  }

  .review-cnt {
    cursor: pointer;
  }
`;
